//
//
//
//
//
//
//
//

export default {
  name: "App",
  data() {
    return {
      transitionName: "",
      index: 0
    };
  },
  watch: {
    $route(to, from, next) {
      // 没有设置 store
      // this.$route.params.index = this.$store.getters.getIndex;
      // this.$store.commit("setRranisitionName", {
      //   toName: { index: to.params.index, name: to.name },
      //   fromName: { index: from.params.index, name: from.name },
      //   backTag: to.params.backTag,
      //   backNum: to.params.backNum
      // });
      // this.transitionName = this.$store.getters.getTransitionName;
    }
  }
};



// WEBPACK FOOTER //
// ./src/App.vue